
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/sales-team",
      function () {
        return require("private-next-pages/solutions/sales-team.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/sales-team"])
      });
    }
  